/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { ReduxUtils } from '@spm/core';
import Constants from '../App/constants';
/* feature name */

var featureName = 'Login';
/**
 * Sets the login user input.
 */

var LOGIN_USER_INPUT = ReduxUtils.generateActionType(Constants.LIBRARY_ROOT, featureName, 'LOGIN_USER_INPUT');
/**
 * Sets the login validation error messages.
 */

var LOGIN_VALIDATION_ERRORS = ReduxUtils.generateActionType(Constants.LIBRARY_ROOT, featureName, 'LOGIN_VALIDATION_ERRORS');
var POST_ACTION_TYPES = ReduxUtils.generatePostActionTypes(Constants.LIBRARY_ROOT, featureName);
export { LOGIN_USER_INPUT, LOGIN_VALIDATION_ERRORS, POST_ACTION_TYPES };